import React from 'react';
import { FILTER_CONFIG_NAMES } from './DataConstants';
import { getIsActiveFilterField } from './FilterUtils';
import LabelDisplay from '../components/LabelDisplay';

export const LABEL_FILTER_RENDER_FIELDS = {
	labelAccessor: (tag) => <LabelDisplay tag={tag} />,
	renderItem: (tag) => <LabelDisplay tag={tag} />,
	renderSelectedText: (tag) => tag.label,
	// LabelsDropdown is a TreeSelect and uses `renderRecord` as each node's title.
	// AdvancedFilters injects a default renderRecord that returns a <Select.Option>
	// (a null-rendering placeholder), which would make the parts Labels options blank.
	// Provide a real renderer so the tree titles show the label.
	renderRecord: (tag) => <LabelDisplay tag={tag} />,
};

export const getPartsFilterConfig = ({ filters, updateFilters, targetCollectionName }) => {
	const vendorFilter = filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS]
		? {
				...filters[FILTER_CONFIG_NAMES.DEFAULT_VENDORS],
				handleChange: undefined,
		  }
		: null;

	const labelsFilter = filters[FILTER_CONFIG_NAMES.PART_LABELS]
		? {
				...filters[FILTER_CONFIG_NAMES.PART_LABELS],
				handleChange: undefined,
				...LABEL_FILTER_RENDER_FIELDS,
		  }
		: null;

	const manufacturerFilter = filters[FILTER_CONFIG_NAMES.PART_MANUFACTURER_NAME]
		? {
				...filters[FILTER_CONFIG_NAMES.PART_MANUFACTURER_NAME],
				handleChange: undefined,
		  }
		: null;

	return [
		getIsActiveFilterField(updateFilters, targetCollectionName, true),
		vendorFilter,
		labelsFilter,
		manufacturerFilter,
	].filter(Boolean);
};
